import vTile from './Tile.vue';

export { vTile }



// WEBPACK FOOTER //
// ./src/baseComponents/components/Tile/index.js